import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Response } from '@angular/http';

import { environment } from '../../environments/environment';
const config = environment.config;

import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import 'rxjs/add/observable/throw';

import { User } from './user';

// Http service to perform login operation
// import this to your login.component and use signIn() to log user in

@Injectable()
export class UserService {

  private userUrl = config.API_BASE_URL + '/user';

  constructor(private http: HttpClient) {}

  toggleMinimized(): Observable < User > {
    return this.http.get(this.userUrl + '/toggleMinimized')
      .map(this.extractData)
      .catch(this.handleError);
  }

  private extractData(res: Response) {
    
    return res['data'] || {};
  }

  private handleError(error: Response | any) {

    return Observable.throw(error.error);
  }
}


// WEBPACK FOOTER //
// ./src/app/authentication/user.service.ts